import OrderEditorAPIService from '@/modules/ordereditor/services/apiService'


export default class OrdersModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.orderEditorService = new OrderEditorAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/ordereditor/configuration',
        name: 'OrderEditorConfiguration',
        component: () => import('@/modules/ordereditor/views/orderEditorConfiguration.vue'),
        meta: {
          requiresAuth: true,
          title: 'Order Editor Configuration',
          menuLink: '/ordereditor/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      }
    ]
  }
}
